export const dictionaryEN = {
  Book: "Book",
  Continue: "Continue",
  "Continue to checkout": "Continue to checkout",
  "Enhance your booking": "Enhance your booking",
  "/hr": "/hr",
  people: "people",
  person: "person",
  Location: "Location",
  "City: Any": "City: Any",
  "State: Any": "State: Any",
  "Location: Any": "Location: Any",
  "Capacity: Any": "Capacity: Any",
  Filter: "Filter",
  Filters: "Filters",
  "{numberOfRooms} rooms found": "{numberOfRooms} rooms found",
  Office: "Office",
  "{count} offerings at {locationName}": "{count} offerings at {locationName}",
  "On Demand": "On Demand",
  Memberships: "Memberships",
  Any: "Any",
  "Any location": "Any",
  "Any city": "Any",
  view: "view",
  "Invitations already sent to:": "Invitations already sent to:",
  and: "and",
  "Available on": "Available on",
  "Available on {date}": "Available on {date}",
  "Best price available today": "Best price available today",
  "Best price available tomorrow": "Best price available tomorrow",
  "Best price available on {date}": "Best price available on {date}",
  "No available space": "No available space",
  "View More": "View More",
  "Additional offices at this location": "Additional offices at this location",
  Floor: "Floor",
  "With window": "With window",
  "Day offices at-{locationName}": "Day offices at-{locationName}",
  "Not sure?": "Not sure?",
  "Talk with us": "Talk with us",
  "We couldn't get a price for this selection. Please try again.":
    "We couldn't get a price for this selection. Please try again.",
  "We are sorry, but there is no availability for 1 pass":
    "We are sorry, but there is no availability for 1 pass",
  "We are sorry, but this date is unavailable at this location. Please pick a different date":
    "We are sorry, but this date is unavailable at this location. Please pick a different date",
  "The dates you selected may be unavailable at this location. Try different dates or clear the date filter.":
    "The dates you selected may be unavailable at this location. Try different dates or clear the date filter.",
  "We are sorry, but there is no availability for {number of passes} passes":
    "We are sorry, but there is no availability for {number of passes} passes",
  "and we may be able to help you find a solution.":
    "and we may be able to help you find a solution.",
  max: "max",
  "Have more questions?": "Have more questions?",
  "Visit our FAQ": "Visit our FAQ",
  "Frequently asked questions": "Frequently asked questions",
  Directions: "Directions",
  "is located at": "is located at",
  "Not available": "Not available",
  Total: "Total",
  to: "to",
  "/day": "/day",
  "/hour": "/hour",
  "/month": "/month",
  From: "From",
  "Quantity:": "Quantity:",
  Quantity: "Quantity",
  Save: "Save",
  When: "When",
  Back: "Back",
  "Please select a location": "Please select a location",
  "Please select date range": "Please select date range",
  "Please select # of entries": "Please select # of entries",
  "Please select date": "Please select date",
  "Please select time": "Please select time",
  "Please select duration": "Please select duration",
  "Please select quantity": "Please select quantity",
  day: "day",
  days: "days",
  "1 day": "1 day",
  "{number of days} days": "{number of days} days",
  "1 working day": "1 working day",
  "{number of working days} working days":
    "{number of working days} working days",
  "Valid for {numberOfDays} day from purchase":
    "Valid for {numberOfDays} day from purchase",
  "Valid for {numberOfDays} days from purchase":
    "Valid for {numberOfDays} days from purchase",
  "1 hour": "1 hour",
  "{number of hours} hours": "{number of hours} hours",
  "1 entry": "1 entry",
  "{number of entries} entries": "{number of entries} entries",
  entry: "entry",
  entries: "entries",
  hour: "hour",
  hours: "hours",
  Close: "Close",
  Update: "Update",
  Amenities: "Amenities",
  "Powered by": "Powered by",
  Privacy: "Privacy",
  Terms: "Terms",
  QTY: "QTY",
  Subtotal: "Subtotal",
  "Cancel for free up to {duration} before your booking":
    "Cancel for free up to {duration} before your booking",
  "Cancel for free up to ": "Cancel for free up to ",
  "Cancel for free up to {time} the day before your booking":
    "Cancel for free up to {time} the day before your booking",
  "Fits: {capacity} people max": "Fits: {capacity} people max",
  "Free cancellation before {time} on {date}":
    "Free cancellation before {time} on {date}",
  "This booking is non-refundable.": "This booking is non-refundable.",
  "{max} max": "{max} max",
  "Up to {capacity} people": "Up to {capacity} people",
  "Up to {capacity} person": "Up to {capacity} person",
  "End time": "End time",
  "Start time": "Start time",
  "View all images": "View all images",
  "Full name": "Full name",
  "Phone number": "Phone number",
  Email: "Email",
  "Number of expected guests": "Number of expected guests",
  "Company Name": "Company Name",
  "Street address": "Street address",
  "City / Town": "City / Town",
  "State / Province / Region": "State / Province / Region",
  "State / Province / Region (optional)":
    "State / Province / Region (optional)",
  "Postal code": "Postal code",
  Country: "Country",
  "Tax / VAT / ID number": "Tax / VAT / ID number",
  "Enter a promo code": "Enter a promo code",
  "Promo code": "Promo code",
  "Payment details": "Payment details",
  "Confirm and Pay": "Confirm and Pay",
  "You won't be charged unless your request is accepted.":
    "You won't be charged unless your request is accepted.",
  "Request to Subscribe": "Request to Subscribe",
  "Request to Book": "Request to Book",
  "Continue to payment": "Continue to payment",
  "This crash has been reported to us and we will work on resolving the issue as quickly as possible.":
    "This crash has been reported to us and we will work on resolving the issue as quickly as possible.",
  "By clicking on Confirm and Pay I agree to the":
    "By clicking on Confirm and Pay I agree to the",
  "terms and conditions": "terms and conditions",
  "Billing details": "Billing details",
  "Your details": "Your details",
  "Check here to indicate that you have read and agreed to the":
    "Check here to indicate that you have read and agreed to the",
  Apply: "Apply",
  "Submitting your request": "Submitting your request",
  "Please add your full name": "Please add your full name",
  "Please agree to the terms and conditions":
    "Please agree to the terms and conditions",
  "Please add your company name": "Please add your company name",
  "Please add your phone number": "Please add your phone number",
  "Please enter valid phone number": "Please enter valid phone number",
  "Please add your email": "Please add your email",
  "Please enter valid email": "Please enter valid email",
  "Please add billing street address": "Please add billing street address",
  "Please add billing city": "Please add billing city",
  "Please add billing state / province / region":
    "Please add billing state / province / region",
  "Please add postal code": "Please add postal code",
  "Please add billing country": "Please add billing country",
  "Please add tax information": "Please add tax information",
  "Please enter credit card info": "Please enter credit card info",
  "Let's talk": "Let's talk",
  "We would be happy to provide you with more information and answer your specific office needs.":
    "We would be happy to provide you with more information and answer your specific office needs.",
  "First Name": "First Name",
  "Last Name": "Last Name",
  "How can we help?": "How can we help?",
  Submit: "Submit",
  "Could not get order confirmation": "Could not get order confirmation",
  "Your payment could not be completed. Please check your card details or try another payment method.":
    "Your payment could not be completed. Please check your card details or try another payment method.",
  "Someone else just booked this space. No payment was taken — the hold on your card will disappear shortly.":
    "Someone else just booked this space. No payment was taken — the hold on your card will disappear shortly.",
  "An add-on you selected just sold out for that date. No payment was taken — the hold on your card will disappear shortly.":
    "An add-on you selected just sold out for that date. No payment was taken — the hold on your card will disappear shortly.",
  "Choose another time": "Choose another time",
  "Stripe was not loaded": "Stripe was not loaded",
  "The session has expired. Please refresh the page and try again.":
    "The session has expired. Please refresh the page and try again.",
  "Card component not found": "Card component not found",
  "Payment unsuccessful": "Payment unsuccessful",
  "Redirecting you to confirmation page":
    "Redirecting you to confirmation page",
  Payment: "Payment",
  "Confirmed without payment": "Confirmed without payment",
  "N/A": "N/A",
  "Ending with {last4}": "Ending with {last4}",
  "Confirmed!": "Confirmed!",
  "Thank you for booking with us. A confirmation email has been sent to {email}. We are looking forward to seeing you soon.":
    "Thank you for booking with us. A confirmation email has been sent to {email}. We are looking forward to seeing you soon.",
  "Payment method": "Payment method",
  "Phone (optional)": "Phone (optional)",
  "Please enter at least one attendee.": "Please enter at least one attendee.",
  "Invite Attendees": "Invite Attendees",
  Message: "Message",
  Name: "Name",
  "e.g. Looking forward to seeing you at {offeringName}!":
    "e.g. Looking forward to seeing you at {offeringName}!",
  "Add your attendees below. Their invitation email automatically includes the location, address, and directions.":
    "Add your attendees below. Their invitation email automatically includes the location, address, and directions.",
  "View Invitation": "View Invitation",
  "Will there be others joining you?": "Will there be others joining you?",
  "The invitation email automatically includes the location, address, and directions.":
    "The invitation email automatically includes the location, address, and directions.",
  attendee: "attendee",
  attendees: "attendees",
  "Please add email": "Please add email",
  "Please add name": "Please add name",
  "Invitation sent!": "Invitation sent!",
  "An email invitation have been sent to your attendees with details and directions.":
    "An email invitation have been sent to your attendees with details and directions.",
  Attendees: "Attendees",
  "Attendees:": "Attendees:",
  Done: "Done",
  "Invitation sent to 1 attendee": "Invitation sent to 1 attendee",
  "Invitation sent to {number of attendees} attendees":
    "Invitation sent to {number of attendees} attendees",
  "{number of hours}": "{number of hours}",
  "{number of entries}": "{number of entries}",
  "{number of days}": "{number of days}",
  "Sorry, we couldn’t find anything matching your search.":
    "Sorry, we couldn’t find anything matching your search.",
  "Reset Filter": "Reset Filter",
  "Select a location": "Select a location",
  "Select quantity": "Select quantity",
  "Select number of guests": "Select number of guests",
  "Please select the number of guests": "Please select the number of guests",
  "Select # of entries": "Select # of entries",
  "{productTypeName} at {locationName}": "{productTypeName} at {locationName}",
  "Other meeting rooms at {locationName}":
    "Other meeting rooms at {locationName}",
  "Other meeting rooms available at the same time":
    "Other meeting rooms available at the same time",
  "{productTypeName} to {locationName}": "{productTypeName} to {locationName}",
  Capacity: "Capacity",
  "Capacity:": "Capacity:",
  "Image for illustration purpose only": "Image for illustration purpose only",
  "Send Invitations": "Send Invitations",
  ILS: "ILS",
  "on {cancelledAt}.": "on {cancelledAt}.",
  "Order cancelled": "Order cancelled",
  "Cancelled and refunded ": "Cancelled and refunded ",
  "Cancel Order": "Cancel Order",
  "Cancel available in {time}": "Cancel available in {time}",
  "Cancel temporarily unavailable while invoice is processing":
    "Cancel temporarily unavailable while invoice is processing",
  "Finalizing the invoice with your space provider. Cancellation will be available shortly.":
    "Finalizing the invoice with your space provider. Cancellation will be available shortly.",
  "Cancellation temporarily unavailable, available in approximately {minutes} minutes":
    "Cancellation temporarily unavailable, available in approximately {minutes} minutes",
  "Cancellation now available": "Cancellation now available",
  Cancellation: "Cancellation",
  "Are you sure you want to cancel and get a refund? This cannot be un-done.":
    "Are you sure you want to cancel and get a refund? This cannot be un-done.",
  "No, do not cancel": "No, do not cancel",
  "Yes, Cancel & Refund": "Yes, Cancel & Refund",
  "Or call us at:": "Or call us at:",
  "Additional Products": "Additional Products",
  "Book now": "Book now",
  "Subscribe now": "Subscribe now",
  "Coming Soon": "Coming Soon",
  "Manage bookings": "Manage bookings",
  "Learn more": "Learn more",
  Daily: "Daily",
  "1 Daily Pass": "1 Daily Pass",
  "Unlimited access": "Unlimited access",
  Confirm: "Confirm",
  "Start from": "Start from",
  "There are no offices available for the selected capacity.":
    "There are no offices available for the selected capacity.",
  Date: "Date",
  Clear: "Clear",
  "Our Customers Say": "Our Customers Say",
  "Review from Google": "Review from Google",
  phoneNumberOptional: "Phone number (optional)",
  "Please add your first name": "Please add your first name",
  "Please add your last name": "Please add your last name",
  "Please enter a valid email": "Please enter a valid email",
  "Please enter a valid phone number": "Please enter a valid phone number",
  "Message can't be blank": "Message can't be blank",
  bookingReasonTitle: "What is the purpose of your booking",
  bookingReasonTitleOptional: "Tell us more about your booking (Optional)",
  specialInstructionsTitle: "Special instructions (Optional)",
  specialInstructionsDisplayTitle: "Special instructions",
  "E.g Catering, Beverages or equipment":
    "E.g Catering, Beverages or equipment",
  missingBookingReasonError: "Please add the purpose of your booking",
  bookingReason: "Booking Reason",
  selectADate: "Select a Date",
  "More to explore...": "More to explore...",
  backTo: "Back to",
  showFewerAmenities: "Show fewer amenities",
  showAllAmenities: "Show all amenities",
  needHelp: "Need help?",
  Home: "Home",
  Guest: "Guest",
  Guests: "Guests",
  "Guest {capacity}": "{capacity} Guest",
  "Guests {capacity}": "{capacity} Guests",
  copy: "Copy",
  copied: "Copied",
  generalInformation: "General Information",
  "Single pass": "Single pass",
  "Select capacity": "Select capacity",
  "Enter a code": "Enter a code",
  "You've already got the best deal! Save your code for another booking.":
    "You've already got the best deal! Save your code for another booking.",
  "Your code beats the {discount}, so we used it instead.":
    "Your code beats the {discount}, so we used it instead.",
  "You've already used all the credit on this code.":
    "You've already used all the credit on this code.",
  "This booking uses all your remaining credit.":
    "This booking uses all your remaining credit.",
  "You'll have {left} credit left after this booking.":
    "You'll have {left} credit left after this booking.",
  "Your credit covers {taken} of this series. No credit left after this booking.":
    "Your credit covers {taken} of this series. No credit left after this booking.",
  "Your credit covers {taken} of this series. You'll have {left} credit left after this booking.":
    "Your credit covers {taken} of this series. You'll have {left} credit left after this booking.",
  "Your code saved {amount} on {appliedTo}. {setAsideOn} already had a better deal: {discount}.":
    "Your code saved {amount} on {appliedTo}. {setAsideOn} already had a better deal: {discount}.",
  "Your code saved {amount} on {appliedTo}. Your booking already had a better deal: {discount}.":
    "Your code saved {amount} on {appliedTo}. Your booking already had a better deal: {discount}.",
  "your booking": "your booking",
  "Update booking details": "Update booking details",
  "Select booking details": "Select booking details",
  "Book this space": "Book this space",
  "Check availability": "Check availability",
  "Select date": "Select date",
  "No start dates are available": "No start dates are available",
  "Every date in this membership's start date window is closed or unavailable. Please contact us to arrange a start date.":
    "Every date in this membership's start date window is closed or unavailable. Please contact us to arrange a start date.",
  City: "City",
  "Select a city": "Select a city",
  "Select a country": "Select a country",
  "Book here": "Book here",
  somethingWentWrong: "Something went wrong",
  availabilityFetchingError:
    "We're unable to check available rooms at this moment, please try again later.",
  "Cancellation policy": "Cancellation policy",
  "{percent}% refund if cancelled {duration} before booking":
    "{percent}% refund if cancelled {duration} before booking",
  "{percent}% refund if cancelled by {time} the day before your booking":
    "{percent}% refund if cancelled by {time} the day before your booking",
  "Payment information": "Payment information",
  "Thank you {firstName}, we will get back to you as soon as we can and reply to your email at {email}.":
    "Thank you {firstName}, we will get back to you as soon as we can and reply to your email at {email}.",
  "By providing your card information, you allow {partnerName} to charge your card for future payments in accordance with their ":
    "By providing your card information, you allow {partnerName} to charge your card for future payments in accordance with their ",
  "Terms of Service": "Terms of Service",
  share: "Share",
  backToAllOffering: "Back to All Offerings",
  backToAllMemberships: "Back to all memberships",
  Accessibility: "Accessibility",
  priceInfoMessage: "Price is based on availability",
  priceInfoMessageV2: "Price varies by availability.",
  priceChargedMessage: "You won’t be charged yet.",
  from: "from",
  "Already have a reservation": "Already have a reservation?",
  Yes: "Yes",
  No: "No",
  "You are now a {partnerName} member. A confirmation email has been sent to {email} with further instructions to activate your membership. We are looking forward to seeing you soon.":
    "You are now a {partnerName} member. A confirmation email has been sent to {email} with further instructions to activate your membership. We are looking forward to seeing you soon.",
  "Welcome to {partnerName}!": "Welcome to {partnerName}!",
  "We’ve chosen the best possible price for you based on your selections":
    "We’ve chosen the best possible price for you based on your selections",
  "Available spaces": "Available spaces",
  "Here are some additional spaces you might be interested in, available during our working hours 09:00-17:30":
    "Here are some additional spaces you might be interested in, available during our working hours 09:00-17:30",
  "To get the most out of your Coworking membership, you’ll need to activate your member portal. To get started, click the button below to set your password and login.":
    "To get the most out of your Coworking membership, you’ll need to activate your member portal. To get started, click the button below to set your password and login.",
  "To access your member portal, login with the same credentials you used for your multi passes.":
    "To access your member portal, login with the same credentials you used for your multi passes.",
  "Login to your member portal to access your new membership.":
    "Login to your member portal to access your new membership.",
  "Activate your member portal": "Activate your member portal",
  "Set my password": "Set my password",
  Login: "Login",
  "Book {numberOfHours}+ hours, save {savingValue} on select dates":
    "Book {numberOfHours}+ hours, save {savingValue} on select dates",
  "Membership options": "Membership options",
  Locations: "Locations",
  "Book {numberOfHours}+ hours to unlock {savingDisplay} off.":
    "Book {numberOfHours}+ hours to unlock {savingDisplay} off.",
  "before VAT per day": " before VAT /day",
  "before VAT per hour": " before VAT /hour",
  "before VAT": " before VAT",
  "You're saving {price}": "You're saving {price}",
  "Clear filters": "Clear filters",
  "Need more flexibility? Discover the benefits of memberships today!":
    "Need more flexibility? Discover the benefits of memberships today!",
  "See details": "See details",
  Where: "Where",
  Anywhere: "Anywhere",
  "{numberOfCities} cities, {numberOfBuildings} buildings":
    "{numberOfCities} cities, {numberOfBuildings} buildings",
  "{numberOfStates} states, {numberOfBuildings} buildings":
    "{numberOfStates} states, {numberOfBuildings} buildings",
  "Clear selection": "Clear selection",
  "Clear search": "Clear search",
  'No locations match "{query}"': 'No locations match "{query}"',
  "See results": "See results",
  "Search for a city": "Search for a city",
  "Search for a state": "Search for a state",
  Neighborhood: "Neighborhood",
  "Select a neighborhood": "Select a neighborhood",
  "Search for a neighborhood": "Search for a neighborhood",
  "{numberOfNeighborhoods} neighborhoods, {numberOfBuildings} buildings":
    "{numberOfNeighborhoods} neighborhoods, {numberOfBuildings} buildings",
  "Book {numberOfHours}+ hours, save {savingDisplay}":
    "Book {numberOfHours}+ hours, save {savingDisplay}",
  min: "min",
  mins: "mins",
  "1 hr": "1 hr",
  "{numberOfHours} hrs": "{numberOfHours} hrs",
  "{numberOfMinutes} mins": "{numberOfMinutes} mins",
  "You're saving {savingDisplay}!": "You're saving {savingDisplay}!",
  "First {cycles} months payment": "First {cycles} months payment",
  "After the initial month, you'll be billed {amount}/month on or about the first of the month.":
    "After the initial month, you'll be billed {amount}/month on or about the first of the month.",
  "{percent}% off for your whole membership":
    "{percent}% off for your whole membership",
  "Discounted price for your whole membership":
    "Discounted price for your whole membership",
  "Your {savingDisplay} off code is": "Your {savingDisplay} off code is",
  "Get {savingDisplay} off your next order!":
    "Get {savingDisplay} off your next order!",
  "Sign up to receive exclusive promotions and discounts, and receive {savingDisplay} off your next order!":
    "Sign up to receive exclusive promotions and discounts, and receive {savingDisplay} off your next order!",
  "Daily rate includes {bookable_start_time} - {bookable_end_time} access":
    "Daily rate includes {bookable_start_time} - {bookable_end_time} access",
  "{savingDisplay} off applied at checkout":
    "{savingDisplay} off applied at checkout",
  "Get {savingDisplay} Off!": "Get {savingDisplay} Off!",
  "We'll show rooms that fit": "We'll show rooms that fit",
  "and more spacious options if available.":
    "and more spacious options if available.",
  "{count}+ people": "{count}+ people",
  "event spaces": "event spaces",
  "Contact us": "Contact us",
  "For larger groups, explore our": "For larger groups, explore our",
  "for larger groups": "for larger groups",
  Who: "Who",
  "Any number of people": "Any number of people",
  "contact us": "contact us",
  or: "or",
  "Enter the minimum or expected number of people":
    "Enter the minimum or expected number of people",
  "Checkout session expired": "Checkout session expired",
  "Your checkout session has expired. Please refresh your page.":
    "Your checkout session has expired. Please refresh your page.",
  "Refresh Page": "Refresh Page",
  "Order is being disputed": "Order is being disputed",
  "Order was disputed": "Order was disputed",
  "Please add your membership number": "Please add your membership number",
  "Please enter only ten digits": "Please enter only ten digits",
  "Membership details": "Membership details",
  "Member ID Barcode": "Member ID Barcode",
  "Thank you for your request. We will review the details and confirm availability shortly. This is a request to book, not a guaranteed reservation. You will receive a confirmation email at {email} once your booking is approved.":
    "Thank you for your request. We will review the details and confirm availability shortly. This is a request to book, not a guaranteed reservation. You will receive a confirmation email at {email} once your booking is approved.",
  "Thank you for your request. We will review the details and confirm availability shortly. This is a request to subscribe, not a guaranteed subscription. You will receive a confirmation email at {email} once your subscription is approved.":
    "Thank you for your request. We will review the details and confirm availability shortly. This is a request to subscribe, not a guaranteed subscription. You will receive a confirmation email at {email} once your subscription is approved.",
  "Request Submitted!": "Request Submitted!",
  // Amenity management
  "Add amenity": "Add amenity",
  "Edit amenity": "Edit amenity",
  "Edit description": "Edit description",
  "Remove from library": "Remove from library",
  "Remove from library?": "Remove from library?",
  "Removing…": "Removing…",
  Remove: "Remove",
  "Adding…": "Adding…",
  "Saving…": "Saving…",
  Cancel: "Cancel",
  Add: "Add",
  "1. Pick an icon": "1. Pick an icon",
  "2. Describe it": "2. Describe it",
  "Search icons": "Search icons",
  "Search your library": "Search your library",
  "How would you describe this for customers?":
    "How would you describe this for customers?",
  "Aim for 25 characters or fewer so the label fits on one line.":
    "Aim for 25 characters or fewer so the label fits on one line.",
  "Over 25 characters — the label may wrap on desktop. Consider trimming.":
    "Over 25 characters — the label may wrap on desktop. Consider trimming.",
  "Over 40 characters — the label will wrap on every screen. Trim it down.":
    "Over 40 characters — the label will wrap on every screen. Trim it down.",
  Description: "Description",
  "Amenity added to your library.": "Amenity added to your library.",
  "Could not add amenity. Please try again.":
    "Could not add amenity. Please try again.",
  "Amenity updated.": "Amenity updated.",
  "Could not update amenity. Please try again.":
    "Could not update amenity. Please try again.",
  "No icons match your search.": "No icons match your search.",
  "Don't see what you need?": "Don't see what you need?",
  "Add to your library.": "Add to your library.",
  added: "added",
  "Amenity attached.": "Amenity attached.",
  "Could not attach. Please try again.": "Could not attach. Please try again.",
  "Your amenity library is empty. Add one to get started.":
    "Your amenity library is empty. Add one to get started.",
  "Add to your library": "Add to your library",
  "Build your amenity library": "Build your amenity library",
  "Pick amenities from our catalog and describe each one. Drag to reorder — customers see them in this order on every space and location.":
    "Pick amenities from our catalog and describe each one. Drag to reorder — customers see them in this order on every space and location.",
  "Pick from our icon catalog and describe each amenity in your own words.":
    "Pick from our icon catalog and describe each amenity in your own words.",
  "This change is visible to guests immediately.":
    "This change is visible to guests immediately.",
  "Could not save the new order.": "Could not save the new order.",
  "Amenity removed.": "Amenity removed.",
  "Could not remove. Please try again.": "Could not remove. Please try again.",
  "Could not detach amenity (missing identifier).":
    "Could not detach amenity (missing identifier).",
  "Could not detach.": "Could not detach.",
  "Could not detach amenity.": "Could not detach amenity.",
  "No location amenities added yet.": "No location amenities added yet.",
  "for this space": "for this space",
  "fixed rate": "fixed rate",
  "per day": "per day",
  "per booking": "per booking",
  "per guest, daily": "per guest, daily",
  "per item, daily": "per item, daily",
  Catalogs: "Catalogs",
  Catalog: "Catalog",
  "No catalogs yet": "No catalogs yet",
  "Not on a catalog": "Not on a catalog",
  "Your catalogs will appear here once they're set up. To add one, email help@flexspace.ai.":
    "Your catalogs will appear here once they're set up. To add one, email help@flexspace.ai.",
  "1 offering": "1 offering",
  "Catalog not found": "Catalog not found",
  "This catalog isn't available. It may have been renamed or removed.":
    "This catalog isn't available. It may have been renamed or removed.",
  "Back to Catalogs": "Back to Catalogs",
  "Your profile": "Your profile",
  "Follow us on LinkedIn": "Follow us on LinkedIn",
  Partner: "Partner",
  "Account type": "Account type",
  "White-label": "White-label",
  Teams: "Teams",
  "1 location": "1 location",
  "Sign out": "Sign out",
  "Your account": "Your account",
  Edit: "Edit",
  "Save changes": "Save changes",
  "Profile updated.": "Profile updated.",
  "Your full name": "Your full name",
  "Please enter your name.": "Please enter your name.",
  "Couldn't save your changes. Please try again.":
    "Couldn't save your changes. Please try again.",
  "Unavailable on {days} — the add-on will skip that day.":
    "Unavailable on {days} — the add-on will skip that day.",
  "Unavailable on {days} — the add-on will skip those days.":
    "Unavailable on {days} — the add-on will skip those days.",
  "Removed {addOns} — no longer available for your booking.":
    "Removed {addOns} — no longer available for your booking.",
  "Removed {addOns} — sold out for your booking.":
    "Removed {addOns} — sold out for your booking.",
  "Removed {addOns} — sold out on {date}.":
    "Removed {addOns} — sold out on {date}.",
  "Removed {addOns} — sold out for a party of {guests} on {date}.":
    "Removed {addOns} — sold out for a party of {guests} on {date}.",
  "Fully booked on {days} — the add-on will skip that day.":
    "Fully booked on {days} — the add-on will skip that day.",
  "Fully booked on {days} — the add-on will skip those days.":
    "Fully booked on {days} — the add-on will skip those days.",
  "Only {count} left": "Only {count} left",
  "Minimum {count}": "Minimum {count}",
  "Minimum {count} per day": "Minimum {count} per day",
  "Minimum {count} per day, based on guest count":
    "Minimum {count} per day, based on guest count",
  "Minimum {count} per booking": "Minimum {count} per booking",
  "Items per day": "Items per day",
  "Items per booking": "Items per booking",
  "From {price}/day (min {count}/day)": "From {price}/day (min {count}/day)",
  "{perDay}/day × {days} · {total}": "{perDay}/day × {days} · {total}",
  "{perDay}/day": "{perDay}/day",
  "{qty} per day × {days} = {items}": "{qty} per day × {days} = {items}",
  "Select at least one day": "Select at least one day",
  each: "each",
  "Add to booking · {total}": "Add to booking · {total}",
  "Update booking · {total}": "Update booking · {total}",
  "{count} is the minimum per day. Use Remove from booking if you don't want {name}.":
    "{count} is the minimum per day. Use Remove from booking if you don't want {name}.",
  "{count} is the minimum per booking. Use Remove from booking if you don't want {name}.":
    "{count} is the minimum per booking. Use Remove from booking if you don't want {name}.",
  Team: "Team",
  Role: "Role",
  Admin: "Admin",
  Standard: "Standard",
  Actions: "Actions",
  "Add user": "Add user",
  "Remove user": "Remove user",
  Member: "Member",
  member: "member",
  members: "members",
  admin: "admin",
  admins: "admins",
  "Team actions for {member}": "Team actions for {member}",
  "(you)": "(you)",
  "{email} · (you)": "{email} · (you)",
  "Reset password": "Reset password",
  "Send invite": "Send invite",
  "Send reset email": "Send reset email",
  "Sending…": "Sending…",
  "Try again": "Try again",
  "We couldn't load our payment provider":
    "We couldn't load our payment provider",
  "An ad blocker, privacy extension, or restricted network can block it. Allow this page, or try a different browser.":
    "An ad blocker, privacy extension, or restricted network can block it. Allow this page, or try a different browser.",
  "If the payment form doesn't appear, close this window and start your booking again.":
    "If the payment form doesn't appear, close this window and start your booking again.",
  "Please add their name.": "Please add their name.",
  "Please add a valid email.": "Please add a valid email.",
  "Invite sent to {email}": "Invite sent to {email}",
  "Role updated.": "Role updated.",
  "User removed.": "User removed.",
  "Password reset email sent.": "Password reset email sent.",
  "Something went wrong. Please try again.":
    "Something went wrong. Please try again.",
  "Remove {name}": "Remove {name}",
  "{count} {name}": "{count} {name}",
  "Remove {name}?": "Remove {name}?",
  "Remove this user?": "Remove this user?",
  "This removes their access to this dashboard. Their account is kept and they can be re-added later.":
    "This removes their access to this dashboard. Their account is kept and they can be re-added later.",
  "You're removing yourself — you'll lose access immediately.":
    "You're removing yourself — you'll lose access immediately.",
  "Send a password reset email to {email}?":
    "Send a password reset email to {email}?",
  "Change role to Admin": "Change role to Admin",
  "Change role to Standard": "Change role to Standard",
  "Send password reset": "Send password reset",
  "Full dashboard access, except the Settings section.":
    "Full dashboard access, except the Settings section.",
  "Everything a standard user can do, plus Settings — notifications and team management.":
    "Everything a standard user can do, plus Settings — notifications and team management.",
  "They'll receive an email invitation to set their password.":
    "They'll receive an email invitation to set their password.",
  "Manage who can access the {partnerName} dashboard.":
    "Manage who can access the {partnerName} dashboard.",
  "No team members yet": "No team members yet",
  "Search by name or email": "Search by name or email",
  "No members matched": "No members matched",
  "No one on your team matches that search. Clear it to see everyone again.":
    "No one on your team matches that search. Clear it to see everyone again.",
  "Matching {search}": "Matching {search}",
  "Add a team member to give them access to this dashboard.":
    "Add a team member to give them access to this dashboard.",
  Settings: "Settings",
  "You don't have access to the catalog":
    "You don't have access to the catalog",
  "Ask one of your admins to grant you catalog access.":
    "Ask one of your admins to grant you catalog access.",
  Payouts: "Payouts",
  Marketing: "Marketing",
  Performance: "Performance",
  FAQ: "FAQ",
  "Offering content": "Offering content",
  "Available to users who see every location":
    "Available to users who see every location",
  "This page covers every location, and you see only some of them. Ask one of your admins if you need it.":
    "This page covers every location, and you see only some of them. Ask one of your admins if you need it.",
  Orders: "Orders",
  Campaigns: "Campaigns",
  "Create orders": "Create orders",
  "Cancel orders and refund": "Cancel orders and refund",
  "Accept or reject requests": "Accept or reject requests",
  "Open and edit the catalog": "Open and edit the catalog",
  "Activate and deactivate products": "Activate and deactivate products",
  "Create and edit campaigns": "Create and edit campaigns",
  "Book on behalf of a customer.": "Book on behalf of a customer.",
  "Cancel an order or a booking and issue refunds.":
    "Cancel an order or a booking and issue refunds.",
  "Decide requested orders and membership requests.":
    "Decide requested orders and membership requests.",
  "See and change spaces, pricing, layouts, images and FAQ.":
    "See and change spaces, pricing, layouts, images and FAQ.",
  "Turn a space or membership on or off for booking.":
    "Turn a space or membership on or off for booking.",
  "Make, edit, archive and label promotions.":
    "Make, edit, archive and label promotions.",
  "Edit permissions": "Edit permissions",
  "What {name} can do in this dashboard.":
    "What {name} can do in this dashboard.",
  "Save permissions": "Save permissions",
  Access: "Access",
  "Full access": "Full access",
  "All permissions": "All permissions",
  "{held} of {total} permissions": "{held} of {total} permissions",
  Permissions: "Permissions",
  "They start with everything. Uncheck what they shouldn't do.":
    "They start with everything. Uncheck what they shouldn't do.",
  "Permissions saved.": "Permissions saved.",
  "Includes locations you add later.": "Includes locations you add later.",
  "Only these locations": "Only these locations",
  "Hides payouts, campaigns, marketing, and the content shared across locations.":
    "Hides payouts, campaigns, marketing, and the content shared across locations.",
  "Choose at least one location, or allow all locations.":
    "Choose at least one location, or allow all locations.",
  "Edit locations": "Edit locations",
  "Which locations {name} sees in this dashboard.":
    "Which locations {name} sees in this dashboard.",
  "Save locations": "Save locations",
  "Locations saved.": "Locations saved.",
  "{count} of {total} locations": "{count} of {total} locations",
  "{count} locations": "{count} locations",
  Owner: "Owner",
  owner: "owner",
  owners: "owners",
  "Change role to Owner": "Change role to Owner",
  "Owners have full access. Change the role to limit it.":
    "Owners have full access. Change the role to limit it.",
  "Everything an admin can do, always with every permission. Only an owner can add or change owners.":
    "Everything an admin can do, always with every permission. Only an owner can add or change owners.",
  "You can only grant permissions you hold.":
    "You can only grant permissions you hold.",
  "Admin access required": "Admin access required",
  "You need an admin role to manage this team. Ask one of your admins to update your role.":
    "You need an admin role to manage this team. Ask one of your admins to update your role.",
  "You need an admin role to view this page. Ask one of your admins to update your role.":
    "You need an admin role to view this page. Ask one of your admins to update your role.",
  "We couldn't load these rooms.": "We couldn't load these rooms.",
  "We couldn't load your team. Check your connection and try again.":
    "We couldn't load your team. Check your connection and try again.",
  "Updating…": "Updating…",
  "A booking made inside this window gets its reminder as soon as it's confirmed.":
    "A booking made inside this window gets its reminder as soon as it's confirmed.",
  "A nudge before the reservation starts. Because it's built at send time, anything time-sensitive you put here — an access code, say — is always the version you last saved.":
    "A nudge before the reservation starts. Because it's built at send time, anything time-sensitive you put here — an access code, say — is always the version you last saved.",
  "Add product type": "Add product type",
  "Add teammate": "Add teammate",
  "All changes saved": "All changes saved",
  "All locations": "All locations",
  "All notifications": "All notifications",
  "Also send a copy to your team": "Also send a copy to your team",
  "An invitation to buy another multi-pass, sent when a customer runs out. Turn it off if you run your own re-engagement emails — from HubSpot, for example.":
    "An invitation to buy another multi-pass, sent when a customer runs out. Turn it off if you run your own re-engagement emails — from HubSpot, for example.",
  "Applies to": "Applies to",
  "Automated emails Flexspace sends your customers. Open one to change what it says, when it goes out, or turn it off.":
    "Automated emails Flexspace sends your customers. Open one to change what it says, when it goes out, or turn it off.",
  "Before the booking starts": "Before the booking starts",
  "Booking reminder": "Booking reminder",
  "Booking reminder saved.": "Booking reminder saved.",
  CC: "CC",
  Custom: "Custom",
  Default: "Default",
  "Every booking": "Every booking",
  "Every confirmed booking gets this reminder.":
    "Every confirmed booking gets this reminder.",
  "Flexspace writes and sends this email — the exact copy is shown in the preview. Editing the wording here is coming; for now you can turn it off or CC your team.":
    "Flexspace writes and sends this email — the exact copy is shown in the preview. Editing the wording here is coming; for now you can turn it off or CC your team.",
  Insert: "Insert",
  "Leave this on your default and it follows every change you make there. A space here can still send its own on top.":
    "Leave this on your default and it follows every change you make there. A space here can still send its own on top.",
  "Merge fields are shown filled in with a sample booking: Priya Raman, Studio 2 at Mission Bay, 9:00 AM.":
    "Merge fields are shown filled in with a sample booking: Priya Raman, Studio 2 at Mission Bay, 9:00 AM.",
  "Mission Bay": "Mission Bay",
  "Multi Day Pass 5 Pack": "Multi Day Pass 5 Pack",
  "Multi-pass top-up": "Multi-pass top-up",
  "Multi-pass top-up saved.": "Multi-pass top-up saved.",
  "No one CC'd": "No one CC'd",
  "No product types match": "No product types match",
  "No reminder goes out until you set one up.":
    "No reminder goes out until you set one up.",
  "Not set": "Not set",
  Notifications: "Notifications",
  Off: "Off",
  "Off sends nothing here, whatever the levels above say.":
    "Off sends nothing here, whatever the levels above say.",
  "Off stops the reminder everywhere.": "Off stops the reminder everywhere.",
  On: "On",
  "Only bookings of certain product types":
    "Only bookings of certain product types",
  "Only bookings of the selected product types get this reminder.":
    "Only bookings of the selected product types get this reminder.",
  Override: "Override",
  "Payment failed": "Payment failed",
  'Pick at least one product type, or switch back to "Every booking".':
    'Pick at least one product type, or switch back to "Every booking".',
  Preview: "Preview",
  "Rebuilt at send time — edits reach every future email":
    "Rebuilt at send time — edits reach every future email",
  Reminder: "Reminder",
  "Reminder email": "Reminder email",
  "Reminder reset — this level inherits again.":
    "Reminder reset — this level inherits again.",
  "Reminders cascade: your default applies everywhere. A location can send its own, and a space can send its own on top of that.":
    "Reminders cascade: your default applies everywhere. A location can send its own, and a space can send its own on top of that.",
  "Remove override": "Remove override",
  "Reset to defaults": "Reset to defaults",
  "Sample booking": "Sample booking",
  "Save reminder": "Save reminder",
  "Search locations": "Search locations",
  "Search product types…": "Search product types…",
  "Search spaces": "Search spaces",
  "See reminder": "See reminder",
  "Sends its own version — every space here inherits it.":
    "Sends its own version — every space here inherits it.",
  "Sent the moment the last pass in a bundle is used — timing can't be changed.":
    "Sent the moment the last pass in a bundle is used — timing can't be changed.",
  "Set up reminder": "Set up reminder",
  "Shown with a sample customer and pass. The wording is what actually goes out; the button and photo take your own branding.":
    "Shown with a sample customer and pass. The wording is what actually goes out; the button and photo take your own branding.",
  Space: "Space",
  "Spaces at": "Spaces at",
  Subject: "Subject",
  "The reminder bookings of this space get, inheriting from its location.":
    "The reminder bookings of this space get, inheriting from its location.",
  "The reminder every booking at this location gets, inheriting from your default.":
    "The reminder every booking at this location gets, inheriting from your default.",
  "The reminder every booking gets before it starts, unless a location or a space sends its own.":
    "The reminder every booking gets before it starts, unless a location or a space sends its own.",
  "They're CC'd on every copy of this email that goes out.":
    "They're CC'd on every copy of this email that goes out.",
  "This email is off, so nobody is receiving it. Your settings are saved and will apply if you turn it back on.":
    "This email is off, so nobody is receiving it. Your settings are saved and will apply if you turn it back on.",
  "This is the most specific level: a reminder set here wins over its location and your default.":
    "This is the most specific level: a reminder set here wins over its location and your default.",
  "This location": "This location",
  "This space": "This space",
  To: "To",
  "Turn this email on or off": "Turn this email on or off",
  "Turn this reminder on or off": "Turn this reminder on or off",
  "Unsaved changes": "Unsaved changes",
  Using: "Using",
  "Using default": "Using default",
  "Using your default — every space here inherits it.":
    "Using your default — every space here inherits it.",
  "We couldn't load your booking reminder. Check your connection and try again.":
    "We couldn't load your booking reminder. Check your connection and try again.",
  "We couldn't reset this reminder. Try again.":
    "We couldn't reset this reminder. Try again.",
  "We couldn't save this reminder. Try again.":
    "We couldn't save this reminder. Try again.",
  "What your customers get": "What your customers get",
  "When a customer uses their last day pass":
    "When a customer uses their last day pass",
  "When it sends": "When it sends",
  "Yours to configure": "Yours to configure",
  custom: "custom",
  "custom version": "custom version",
  "custom versions": "custom versions",
  "hours before the booking starts": "hours before the booking starts",
  location: "location",
  of: "of",
  "reminder settings": "reminder settings",
  space: "space",
  spaces: "spaces",
  "your default": "your default",
  "Space layouts": "Space layouts",
  "See all space layouts": "See all space layouts",
  "All space layouts": "All space layouts",
  Layout: "Layout",
  "Select layout": "Select layout",
  "varies by layout": "varies by layout",
  "Number of people": "Number of people",
  "Our meeting rooms fit up to {max} people.":
    "Our meeting rooms fit up to {max} people.",

  // Staff order confirmation email (Settings -> Notifications)
  "Staff order confirmation": "Staff order confirmation",
  "When an order is confirmed": "When an order is confirmed",
  "Who on your team hears about a confirmed order, and what they read. Set it once for everywhere, then let a location, a product type or a single space differ where it needs to.":
    "Who on your team hears about a confirmed order, and what they read. Set it once for everywhere, then let a location, a product type or a single space differ where it needs to.",
  "Who on your team hears about a confirmed order, and what they read. These apply to every location and space unless a more specific level sets its own.":
    "Who on your team hears about a confirmed order, and what they read. These apply to every location and space unless a more specific level sets its own.",
  "This email cascades: your defaults apply everywhere. A location can set its own, a product type at that location can set its own, and a single space can set its own on top of that.":
    "This email cascades: your defaults apply everywhere. A location can set its own, a product type at that location can set its own, and a single space can set its own on top of that.",
  "Membership staff emails (a new member, a cancellation, a payment) go to these people too, unless the membership's location or the membership itself names its own.":
    "Membership staff emails (a new member, a cancellation, a payment) go to these people too, unless the membership's location or the membership itself names its own.",
  "can still set its own on top.": "can still set its own on top.",
  "Orders of this product type at this location only, inheriting from the location and your defaults.":
    "Orders of this product type at this location only, inheriting from the location and your defaults.",
  "Anything custom here wins over": "Anything custom here wins over",
  "and your defaults. A single space can still set its own on top.":
    "and your defaults. A single space can still set its own on top.",
  "This space only, inheriting from everything above it.":
    "This space only, inheriting from everything above it.",
  "This is the most specific level: anything custom here wins over every other level.":
    "This is the most specific level: anything custom here wins over every other level.",
  Recipients: "Recipients",
  Sender: "Sender",
  "Staff instructions": "Staff instructions",
  "Applies to every order unless a more specific level sets its own list. Overriding replaces every recipient — lists don't merge across levels.":
    "Applies to every order unless a more specific level sets its own list. Overriding replaces every recipient — lists don't merge across levels.",
  "Overriding replaces the inherited list in full — lists don't merge across levels.":
    "Overriding replaces the inherited list in full — lists don't merge across levels.",
  "We couldn't load this email's settings. Check your connection and try again.":
    "We couldn't load this email's settings. Check your connection and try again.",
  "Only an admin can change this email. You can look up any level here.":
    "Only an admin can change this email. You can look up any level here.",
  Defaults: "Defaults",
  "Product type": "Product type",
  "Product types at": "Product types at",
  "Spaces using this product type": "Spaces using this product type",
  "Sits between the location and a single space. A meeting room and a day pass at the same address rarely need the same people notified.":
    "Sits between the location and a single space. A meeting room and a day pass at the same address rarely need the same people notified.",
  "No product type": "No product type",
  "No one": "No one",
  "no one": "no one",
  Open: "Open",
  "Reset all to defaults": "Reset all to defaults",
  "Reset to": "Reset to",
  "reset to defaults.": "reset to defaults.",
  "Couldn't reset this level. Please try again.":
    "Couldn't reset this level. Please try again.",
  "Couldn't upload the file. Please try again.":
    "Couldn't upload the file. Please try again.",
  "Actions for": "Actions for",
  "Using default · from": "Using default · from",
  "saved.": "saved.",
  "Sent to": "Sent to",
  "Everyone here is on the To line. At least one is required.":
    "Everyone here is on the To line. At least one is required.",
  "Reply-to": "Reply-to",
  "Where a reply lands. Optional — leave it empty and replies go to the From address.":
    "Where a reply lands. Optional — leave it empty and replies go to the From address.",
  "From name": "From name",
  "The name your team sees in their inbox.":
    "The name your team sees in their inbox.",
  "Merge fields are filled in when the order is confirmed.":
    "Merge fields are filled in when the order is confirmed.",
  Title: "Title",
  "The heading inside the email.": "The heading inside the email.",
  "Note to your team": "Note to your team",
  "Rebuilt at send time, so a change reaches every future order.":
    "Rebuilt at send time, so a change reaches every future order.",
  Attachment: "Attachment",
  "One PDF, sent with every copy of this email.":
    "One PDF, sent with every copy of this email.",
  "Upload PDF": "Upload PDF",
  Replace: "Replace",
  "Uploading…": "Uploading…",
  "Add recipient": "Add recipient",
  "Add reply-to": "Add reply-to",
  "Add reply-to address": "Add reply-to address",
  "Add 1 recipient": "Add 1 recipient",
  recipient: "recipient",
  recipients: "recipients",
  override: "override",
  overrides: "overrides",
  "Add a recipient to continue.": "Add a recipient to continue.",
  "At least one recipient is required, or reset this level so it falls back to":
    "At least one recipient is required, or reset this level so it falls back to",
  "At least one recipient is required — nothing sends without one.":
    "At least one recipient is required — nothing sends without one.",
  "Anyone here receives the full order details, including the guest's name and email.":
    "Anyone here receives the full order details, including the guest's name and email.",
  "Your team": "Your team",
  "Already added": "Already added",
  "Someone else": "Someone else",
  Address: "Address",
  "is not a valid email address.": "is not a valid email address.",
  "is already on the list.": "is already on the list.",
  "Send test email": "Send test email",
  "Send test": "Send test",
  "Send to": "Send to",
  "What will send": "What will send",
  "We'll send one copy of the": "We'll send one copy of the",
  "version, filled in with a sample order. Your real recipients are not contacted.":
    "version, filled in with a sample order. Your real recipients are not contacted.",
  "Test sent to": "Test sent to",
  "Couldn't send the test. Please try again.":
    "Couldn't send the test. Please try again.",
  "your defaults": "your defaults",
  "reset — this level inherits again.": "reset — this level inherits again.",
  "Staff email": "Staff email",
  "See recipients": "See recipients",
  "can still set its own on top — a meeting room and a day pass at the same address rarely need the same people notified.":
    "can still set its own on top — a meeting room and a day pass at the same address rarely need the same people notified.",
  "Search product types": "Search product types",
  "product type": "product type",
  "Set up": "Set up",
  "Using defaults": "Using defaults",
  "Staff order confirmation saved.": "Staff order confirmation saved.",
  "This product type": "This product type",
  "No one is notified until you name someone.":
    "No one is notified until you name someone.",
  "Merge fields are shown filled in with a sample order: Priya Raman, Studio 2 at Mission Bay, July 30.":
    "Merge fields are shown filled in with a sample order: Priya Raman, Studio 2 at Mission Bay, July 30.",
  "One step more specific than this location: applies to orders of that type here, and a single space can still override it.":
    "One step more specific than this location: applies to orders of that type here, and a single space can still override it.",
  "The most specific level: a space overrides its product type and this location.":
    "The most specific level: a space overrides its product type and this location.",
  "The most specific level: a space overrides this product type and its location.":
    "The most specific level: a space overrides this product type and its location.",
  "This booking link looks incomplete": "This booking link looks incomplete",
  "Some email apps shorten long links. Please open the link from your confirmation email again, or contact the venue if it keeps happening.":
    "Some email apps shorten long links. Please open the link from your confirmation email again, or contact the venue if it keeps happening.",
  "Guest order confirmation": "Guest order confirmation",
  "When a customer books": "When a customer books",
  "The confirmation every customer gets when they book — the welcome note, directions and help section. Set it once for everywhere, then let a location, a product type or a single space differ where it needs to.":
    "The confirmation every customer gets when they book — the welcome note, directions and help section. Set it once for everywhere, then let a location, a product type or a single space differ where it needs to.",
  "What your customers read when a booking is confirmed — the subject, the welcome note, directions and help section. These apply everywhere unless a more specific level sets its own. Every confirmed booking sends one: this email can't be turned off.":
    "What your customers read when a booking is confirmed — the subject, the welcome note, directions and help section. These apply everywhere unless a more specific level sets its own. Every confirmed booking sends one: this email can't be turned off.",
  "The booking confirmation for every order at this location, inheriting from your defaults.":
    "The booking confirmation for every order at this location, inheriting from your defaults.",
  "Anything left on its default here follows your defaults. What you set here also backs this location's add-on and invite confirmation emails. A product type or a single space at":
    "Anything left on its default here follows your defaults. What you set here also backs this location's add-on and invite confirmation emails. A product type or a single space at",
  "Bookings of this product type at this location only, inheriting from the location and your defaults.":
    "Bookings of this product type at this location only, inheriting from the location and your defaults.",
  "Customer email": "Customer email",
  "See what sends": "See what sends",
  "Guest order confirmation saved.": "Guest order confirmation saved.",
  "Subject & title": "Subject & title",
  "Email content": "Email content",
  "Reply-to & attachment": "Reply-to & attachment",
  "The subject and title can carry:": "The subject and title can carry:",
  "Each section falls back to our standard copy when left empty — the preview shows exactly what sends.":
    "Each section falls back to our standard copy when left empty — the preview shows exactly what sends.",
  "Our standard subject": "Our standard subject",
  "welcome note": "welcome note",
  directions: "directions",
  "help section": "help section",
  "Every section sends our standard copy.":
    "Every section sends our standard copy.",
  "Custom copy:": "Custom copy:",
  "Welcome note": "Welcome note",
  "Help section": "Help section",
  "Merge fields fill in when the booking is confirmed. Empty sends our standard subject.":
    "Merge fields fill in when the booking is confirmed. Empty sends our standard subject.",
  "The headline inside the email. Empty sends our standard headline.":
    "The headline inside the email. Empty sends our standard headline.",
  "Opens the email, above the booking details. Empty sends our standard thank-you.":
    "Opens the email, above the booking details. Empty sends our standard thank-you.",
  "Under the email's Directions heading, next to the map link. Empty sends the location's address line.":
    "Under the email's Directions heading, next to the map link. Empty sends the location's address line.",
  "Closes the email. The booking's cancellation policy always sends beneath it, so there is no need to insert it. Empty sends our standard invitation to reply.":
    "Closes the email. The booking's cancellation policy always sends beneath it, so there is no need to insert it. Empty sends our standard invitation to reply.",
  "Where a customer's reply lands. Empty sends replies to the From address.":
    "Where a customer's reply lands. Empty sends replies to the From address.",
  "The name customers see in their inbox.":
    "The name customers see in their inbox.",
  "One PDF, sent with every confirmation.":
    "One PDF, sent with every confirmation.",
  "Opening hours": "Opening hours",
  "The location's opening hours are listed here.":
    "The location's opening hours are listed here.",
  "Our standard help copy: an invitation to reply to this email.":
    "Our standard help copy: an invitation to reply to this email.",
  "This booking's cancellation policy is stated here. It is worked out per booking when the email sends, so it can't be edited.":
    "This booking's cancellation policy is stated here. It is worked out per booking when the email sends, so it can't be edited.",
  "Merge fields are shown filled in with a sample booking: Priya Raman, Studio 2 at Mission Bay, July 30. The preview shows what actually sends — including inherited and standard copy you haven't overridden.":
    "Merge fields are shown filled in with a sample booking: Priya Raman, Studio 2 at Mission Bay, July 30. The preview shows what actually sends — including inherited and standard copy you haven't overridden.",
  "If a product type or space overrides this copy for that booking, the email shows the version that actually sent.":
    "If a product type or space overrides this copy for that booking, the email shows the version that actually sent.",
  "We'll re-send the confirmation from one of your recent bookings — the real email, exactly as that customer received it. It carries that booking's real details, so send it somewhere you'd be comfortable those details going.":
    "We'll re-send the confirmation from one of your recent bookings — the real email, exactly as that customer received it. It carries that booking's real details, so send it somewhere you'd be comfortable those details going.",
  "only the address above": "only the address above",
  // Recurring bookings — the storefront Repeat control
  "These dates are no longer available: {dates}. Choose another time, or turn Repeat off.":
    "These dates are no longer available: {dates}. Choose another time, or turn Repeat off.",
  "Every {weekday}": "Every {weekday}",
  "Every {interval} weeks on {weekday}": "Every {interval} weeks on {weekday}",
  "{span} · {count} bookings": "{span} · {count} bookings",
  "Your bookings": "Your bookings",
  "{date} fell on your pattern but was already taken. It was left out of the recurring booking and was not charged.":
    "{date} fell on your pattern but was already taken. It was left out of the recurring booking and was not charged.",
  "{dates} fell on your pattern but were already taken. They were left out of the recurring booking and were not charged.":
    "{dates} fell on your pattern but were already taken. They were left out of the recurring booking and were not charged.",
  "Thank you for booking with us. A confirmation email covering all {count} bookings has been sent to {email}. We are looking forward to seeing you soon.":
    "Thank you for booking with us. A confirmation email covering all {count} bookings has been sent to {email}. We are looking forward to seeing you soon.",
  "Not refundable. A single date can be cancelled to free the room, but is not refunded.":
    "Not refundable. A single date can be cancelled to free the room, but is not refunded.",
  "Refundable in full until {deadline}. After that, a single date can be cancelled to free the room, but is not refunded.":
    "Refundable in full until {deadline}. After that, a single date can be cancelled to free the room, but is not refunded.",
  "Charged once for the whole recurring booking.":
    "Charged once for the whole recurring booking.",
  "Choose a date and time to repeat this booking.":
    "Choose a date and time to repeat this booking.",
  "Choose a date to repeat this booking.":
    "Choose a date to repeat this booking.",
  "Repeat this booking": "Repeat this booking",
  "Same room and time, every week": "Same room and time, every week",
  "Same room and time, every {weekday}": "Same room and time, every {weekday}",
  Weekly: "Weekly",
  "Every 2 weeks": "Every 2 weeks",
  "Every 3 weeks": "Every 3 weeks",
  "Every 4 weeks": "Every 4 weeks",
  "location closed": "location closed",
  "already booked": "already booked",
  "too soon to book": "too soon to book",
  "too short for this room": "too short for this room",
  unavailable: "unavailable",
  Unavailable: "Unavailable",
  "{count} booking": "{count} booking",
  "{count} bookings": "{count} bookings",
  "Shortened to {count} bookings — a recurring booking has to finish inside the booking window, which ends {date}.":
    "Shortened to {count} bookings — a recurring booking has to finish inside the booking window, which ends {date}.",
  "{count} bookings · {first} – {last}": "{count} bookings · {first} – {last}",
  "Prices confirmed on Save": "Prices confirmed on Save",
  "{count} unavailable date skipped · prices confirmed on Save":
    "{count} unavailable date skipped · prices confirmed on Save",
  "{count} unavailable dates skipped · prices confirmed on Save":
    "{count} unavailable dates skipped · prices confirmed on Save",
  "Repeats {preset} · {count} bookings through {last}":
    "Repeats {preset} · {count} bookings through {last}",
  "{first} through {last}": "{first} through {last}",
  "Every date on this pattern is available.":
    "Every date on this pattern is available.",
  "1 date on this pattern is unavailable and not charged: {list}.":
    "1 date on this pattern is unavailable and not charged: {list}.",
  "{count} dates on this pattern are unavailable and not charged: {list}.":
    "{count} dates on this pattern are unavailable and not charged: {list}.",
  "After discounts": "After discounts",
  "Your recurring booking": "Your recurring booking",
  // Manage-order page — the customer's own view of a booking
  "This booking could not be loaded. Please try again, or contact the venue.":
    "This booking could not be loaded. Please try again, or contact the venue.",
  "1 guest": "1 guest",
  "{count} guests": "{count} guests",
  "This date could not be cancelled.": "This date could not be cancelled.",
  "The booking could not be cancelled.": "The booking could not be cancelled.",
  "This page is for recurring bookings. Your booking is on its confirmation page.":
    "This page is for recurring bookings. Your booking is on its confirmation page.",
  "Open confirmation page": "Open confirmation page",
  "Cancelled on {date}, before the first booking. Every one of the {count} dates was cancelled and {refund} was refunded to your payment method.":
    "Cancelled on {date}, before the first booking. Every one of the {count} dates was cancelled and {refund} was refunded to your payment method.",
  "1 booking cancelled": "1 booking cancelled",
  "Confirmation {code}": "Confirmation {code}",
  "Booked {date}": "Booked {date}",
  "Next booking": "Next booking",
  "Your booking": "Your booking",
  "Cancelled recurring booking": "Cancelled recurring booking",
  "Cancelled booking": "Cancelled booking",
  "No bookings left": "No bookings left",
  "{completed} of {total} bookings completed":
    "{completed} of {total} bookings completed",
  "{done} · booking {next} is next": "{done} · booking {next} is next",
  "Add recurring booking to calendar": "Add recurring booking to calendar",
  "Add to calendar": "Add to calendar",
  "Get directions": "Get directions",
  "Book this again": "Book this again",
  "Book this room again": "Book this room again",
  "This recurring booking was cancelled":
    "This recurring booking was cancelled",
  "This booking was cancelled": "This booking was cancelled",
  "Cancelled on {date}. {refund} was refunded to your payment method.":
    "Cancelled on {date}. {refund} was refunded to your payment method.",
  "Cancelled on {date}. No refund was issued.":
    "Cancelled on {date}. No refund was issued.",
  "No payment was taken online for this booking, so there's nothing to refund. Cancelling frees the room for someone else.":
    "No payment was taken online for this booking, so there's nothing to refund. Cancelling frees the room for someone else.",
  "The room will be freed for someone else. No payment was taken online for this booking, so there's nothing to refund.":
    "The room will be freed for someone else. No payment was taken online for this booking, so there's nothing to refund.",
  "Cancelled on {date}. No payment was taken online for this booking, so nothing was refunded.":
    "Cancelled on {date}. No payment was taken online for this booking, so nothing was refunded.",
  "This booking was free, so there's nothing to refund. Cancelling frees the room for someone else.":
    "This booking was free, so there's nothing to refund. Cancelling frees the room for someone else.",
  "The room will be freed for someone else. This booking was free, so there's nothing to refund.":
    "The room will be freed for someone else. This booking was free, so there's nothing to refund.",
  "Cancelled on {date}. This booking was free, so nothing was refunded.":
    "Cancelled on {date}. This booking was free, so nothing was refunded.",
  "This booking was free, so nothing was refunded.":
    "This booking was free, so nothing was refunded.",
  "Cancelled before the first booking. Every one of the {count} dates was cancelled and {refund} was refunded to your payment method.":
    "Cancelled before the first booking. Every one of the {count} dates was cancelled and {refund} was refunded to your payment method.",
  "{refund} was refunded to your payment method.":
    "{refund} was refunded to your payment method.",
  "No refund was issued.": "No refund was issued.",
  "No payment was taken online for this booking, so nothing was refunded.":
    "No payment was taken online for this booking, so nothing was refunded.",
  Schedule: "Schedule",
  "{count} bookings cancelled": "{count} bookings cancelled",
  "{completed} completed · {cancelled} cancelled · {upcoming} upcoming":
    "{completed} completed · {cancelled} cancelled · {upcoming} upcoming",
  Upcoming: "Upcoming",
  Completed: "Completed",
  Cancelled: "Cancelled",
  "Cancel this date?": "Cancel this date?",
  "{date} will be freed for someone else, and the rest of your recurring booking stays exactly as it is.":
    "{date} will be freed for someone else, and the rest of your recurring booking stays exactly as it is.",
  "This date is not refunded. Your total stays {total}.":
    "This date is not refunded. Your total stays {total}.",
  "Cancel this date": "Cancel this date",
  "Keep this date": "Keep this date",
  "Cancelling this booking": "Cancelling this booking",
  "Dates can be cancelled one at a time but are not refunded. This recurring booking is not refundable.":
    "Dates can be cancelled one at a time but are not refunded. This recurring booking is not refundable.",
  "Cancel the whole recurring booking for a full refund until {deadline}. After that, dates can be cancelled one at a time but are not refunded.":
    "Cancel the whole recurring booking for a full refund until {deadline}. After that, dates can be cancelled one at a time but are not refunded.",
  "Dates can be cancelled but are not refunded. The recurring booking was refundable in full until {deadline}.":
    "Dates can be cancelled but are not refunded. The recurring booking was refundable in full until {deadline}.",
  "Cancel all upcoming": "Cancel all upcoming",
  "Cancel booking": "Cancel booking",
  "Cancel this recurring booking?": "Cancel this recurring booking?",
  "All {count} upcoming dates will be cancelled and the rooms freed. {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "All {count} upcoming dates will be cancelled and the rooms freed. {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.",
  "All 1 upcoming date will be cancelled and the rooms freed. {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "All 1 upcoming date will be cancelled and the rooms freed. {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.",
  "Cancel and refund": "Cancel and refund",
  "Keep booking": "Keep booking",
  "This recurring booking can no longer be refunded":
    "This recurring booking can no longer be refunded",
  "A recurring booking is refundable in full until {deadline}, which has passed. You can still cancel the {count} upcoming dates one at a time, which frees the room on those dates.":
    "A recurring booking is refundable in full until {deadline}, which has passed. You can still cancel the {count} upcoming dates one at a time, which frees the room on those dates.",
  "A recurring booking is refundable in full until {deadline}, which has passed. You can still cancel the 1 upcoming date one at a time, which frees the room on those dates.":
    "A recurring booking is refundable in full until {deadline}, which has passed. You can still cancel the 1 upcoming date one at a time, which frees the room on those dates.",
  "This recurring booking is not refundable. You can still cancel the {count} upcoming dates one at a time, which frees the room on those dates.":
    "This recurring booking is not refundable. You can still cancel the {count} upcoming dates one at a time, which frees the room on those dates.",
  "This recurring booking is not refundable. You can still cancel the 1 upcoming date one at a time, which frees the room on those dates.":
    "This recurring booking is not refundable. You can still cancel the 1 upcoming date one at a time, which frees the room on those dates.",
  "Cancelled dates are not refunded. To ask for an exception, talk with the space directly.":
    "Cancelled dates are not refunded. To ask for an exception, talk with the space directly.",
  "Back to booking": "Back to booking",
  "Service Fee": "Service Fee",
  Tax: "Tax",
  "Refunded {date}": "Refunded {date}",
  "Balance ({currency})": "Balance ({currency})",
  "Total ({currency})": "Total ({currency})",
  "Billed to {address}": "Billed to {address}",
  // The single booking's own page — its duration and its cancellation dialog
  "{count} hours": "{count} hours",
  "{count} days": "{count} days",
  "This booking is not refundable and can't be cancelled online. Please contact the venue if your plans change.":
    "This booking is not refundable and can't be cancelled online. Please contact the venue if your plans change.",
  "The cancellation window for this booking has closed, so it can no longer be cancelled online. Please contact the venue if your plans change.":
    "The cancellation window for this booking has closed, so it can no longer be cancelled online. Please contact the venue if your plans change.",
  "This booking can't be cancelled online. Please contact the venue if your plans change.":
    "This booking can't be cancelled online. Please contact the venue if your plans change.",
  "This booking is not refundable. Cancelling frees the room for someone else but returns nothing.":
    "This booking is not refundable. Cancelling frees the room for someone else but returns nothing.",
  "Cancel this booking for a full refund of {refund}.":
    "Cancel this booking for a full refund of {refund}.",
  "Cancelling this booking returns {percentage}% of what you paid — {refund}.":
    "Cancelling this booking returns {percentage}% of what you paid — {refund}.",
  "Cancel this booking?": "Cancel this booking?",
  "The room will be freed for someone else. This booking is not refundable, so nothing is returned.":
    "The room will be freed for someone else. This booking is not refundable, so nothing is returned.",
  "The room will be freed for someone else and {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "The room will be freed for someone else and {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.",
  "The room will be freed for someone else and {refund} — {percentage}% of what you paid — is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "The room will be freed for someone else and {refund} — {percentage}% of what you paid — is refunded to your payment method. Refunds take 5–10 business days to appear.",
  // The change flow — the hero's action and the three steps of its dialog
  "Change booking": "Change booking",
  "Change available in {time}": "Change available in {time}",
  "This booking can no longer be changed. To move it, talk with the space directly.":
    "This booking can no longer be changed. To move it, talk with the space directly.",
  "This booking could be changed until {deadline}. To move it, talk with the space directly.":
    "This booking could be changed until {deadline}. To move it, talk with the space directly.",
  "Move this booking": "Move this booking",
  "Pick a new date and time for {room}. Everything else about your booking stays as it is.":
    "Pick a new date and time for {room}. Everything else about your booking stays as it is.",
  "This slot costs {price} for {duration}.":
    "This slot costs {price} for {duration}.",
  "This is the slot you already have. Pick a different date or time to move it.":
    "This is the slot you already have. Pick a different date or time to move it.",
  "This slot costs {amount} more, charged when you confirm.":
    "This slot costs {amount} more, charged when you confirm.",
  "This slot costs {amount} more. Your {card} is charged when you confirm.":
    "This slot costs {amount} more. Your {card} is charged when you confirm.",
  "This slot is cheaper. {amount} is refunded to your payment method.":
    "This slot is cheaper. {amount} is refunded to your payment method.",
  "This slot is cheaper. {amount} is refunded to your {card}.":
    "This slot is cheaper. {amount} is refunded to your {card}.",
  "This slot is cheaper, but changes are not partially refunded. Your total stays {paid}.":
    "This slot is cheaper, but changes are not partially refunded. Your total stays {paid}.",
  "Review charge": "Review charge",
  "Review change": "Review change",
  "Keep current slot": "Keep current slot",
  "Move this booking and pay {extra}?": "Move this booking and pay {extra}?",
  "Move this booking?": "Move this booking?",
  Now: "Now",
  "Moving to": "Moving to",
  "Already paid": "Already paid",
  "New slot price": "New slot price",
  "To charge now": "To charge now",
  "To refund": "To refund",
  "Not refunded": "Not refunded",
  "Nothing to pay": "Nothing to pay",
  "Your card is charged as soon as you confirm, and the booking moves once the charge goes through.":
    "Your card is charged as soon as you confirm, and the booking moves once the charge goes through.",
  "{amount} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "{amount} is refunded to your payment method. Refunds take 5–10 business days to appear.",
  "{amount} is refunded to your {card}. Refunds take 5–10 business days to appear.":
    "{amount} is refunded to your {card}. Refunds take 5–10 business days to appear.",
  "Nothing is charged and nothing is refunded — only the date and time change.":
    "Nothing is charged and nothing is refunded — only the date and time change.",
  "Nothing is charged. The {amount} difference is not refunded, so your total stays {paid}.":
    "Nothing is charged. The {amount} difference is not refunded, so your total stays {paid}.",
  "Pay {amount} and move": "Pay {amount} and move",
  "Move booking": "Move booking",
  "Your booking has moved": "Your booking has moved",
  "Your new booking": "Your new booking",
  "Charged to your {card}": "Charged to your {card}",
  "Charged to your payment method": "Charged to your payment method",
  "Refunded to your {card}": "Refunded to your {card}",
  "Refunded to your payment method": "Refunded to your payment method",
  "Total paid": "Total paid",
  "A new confirmation is on its way to {email}.":
    "A new confirmation is on its way to {email}.",
  "{network} ending {last4}": "{network} ending {last4}",
  "This slot could not be priced. Try another date or time.":
    "This slot could not be priced. Try another date or time.",
  "This booking could not be moved. Please try again.":
    "This booking could not be moved. Please try again.",
  "Nothing is charged and nothing is refunded.":
    "Nothing is charged and nothing is refunded.",
  "New price": "New price",
  "Change this booking": "Change this booking",
  "Change the date and time. Everything else about your booking stays as it is.":
    "Change the date and time. Everything else about your booking stays as it is.",
  "Change the space or the time. Everything else about your booking stays as it is.":
    "Change the space or the time. Everything else about your booking stays as it is.",
  "Change the room or the time. Everything else about your booking stays as it is.":
    "Change the room or the time. Everything else about your booking stays as it is.",
  Room: "Room",
  "Date and time": "Date and time",
  Dates: "Dates",
  "This booking can't move to another space. You can still change the date and time.":
    "This booking can't move to another space. You can still change the date and time.",
  "This booking can't move to another room. You can still change the date and time.":
    "This booking can't move to another room. You can still change the date and time.",
  Change: "Change",
  "Pick a time": "Pick a time",
  "Pick dates": "Pick dates",
  "Change the date and time to see the new price.":
    "Change the date and time to see the new price.",
  "Change the space or time to see the new price.":
    "Change the space or time to see the new price.",
  "Change the room or time to see the new price.":
    "Change the room or time to see the new price.",
  "Keep current booking": "Keep current booking",
  "Choose a space": "Choose a space",
  "Choose a room": "Choose a room",
  "Event spaces you can move to.": "Event spaces you can move to.",
  "Meeting rooms you can move to.": "Meeting rooms you can move to.",
  "Event spaces at {address} you can move to.":
    "Event spaces at {address} you can move to.",
  "Meeting rooms at {address} you can move to.":
    "Meeting rooms at {address} you can move to.",
  "Seats up to {count}": "Seats up to {count}",
  "Seats {count}": "Seats {count}",
  Current: "Current",
  "Use this space": "Use this space",
  "Use this room": "Use this room",
  "Checking availability…": "Checking availability…",
  "Available at your time": "Available at your time",
  "Not available at your time": "Not available at your time",
  "Available on your dates": "Available on your dates",
  "Not available on your dates": "Not available on your dates",
  "That space can no longer be booked as a change. Please pick another space.":
    "That space can no longer be booked as a change. Please pick another space.",
  "Choose a layout": "Choose a layout",
  "Pick how {room} is set up. Your guest count stays the same.":
    "Pick how {room} is set up. Your guest count stays the same.",
  "Pick how {room} is set up. Your guest count becomes the seats in the layout you choose.":
    "Pick how {room} is set up. Your guest count becomes the seats in the layout you choose.",
  "Use this layout": "Use this layout",
  "Pick a date and time": "Pick a date and time",
  "For {room}.": "For {room}.",
  "For {room}, {layout}.": "For {room}, {layout}.",
  "Your current time isn't available in {room}. Pick a new time to move there.":
    "Your current time isn't available in {room}. Pick a new time to move there.",
  "Your current dates aren't available in {room}. Pick new dates to move there.":
    "Your current dates aren't available in {room}. Pick new dates to move there.",
  "Use this time": "Use this time",
  "Use these dates": "Use these dates",
  "Your booking will follow {room}'s cancellation policy once it moves.":
    "Your booking will follow {room}'s cancellation policy once it moves.",
  "Your promo code {code} doesn't apply to {room}, so its discount is removed from the new price.":
    "Your promo code {code} doesn't apply to {room}, so its discount is removed from the new price.",
  "We couldn't load {room}. Check your connection and try again.":
    "We couldn't load {room}. Check your connection and try again.",
  // The recurring quote refusal banner — what the quote refused and the way out
  "This time is sold at a non-refundable rate, which cannot be part of a recurring booking. Try a different day or time, or book this date on its own.":
    "This time is sold at a non-refundable rate, which cannot be part of a recurring booking. Try a different day or time, or book this date on its own.",
  "This promo code makes the booking non-refundable, which cannot be part of a recurring booking. Remove the code, or book this date on its own.":
    "This promo code makes the booking non-refundable, which cannot be part of a recurring booking. Remove the code, or book this date on its own.",
  "Bookings at this time need the venue's approval, so they cannot repeat yet. Try a different day or time, or book this date on its own.":
    "Bookings at this time need the venue's approval, so they cannot repeat yet. Try a different day or time, or book this date on its own.",
  "The first date's start time has passed. Update the dates to keep this booking repeating.":
    "The first date's start time has passed. Update the dates to keep this booking repeating.",
  "The chosen dates no longer fit this room's booking window. Update the dates to keep this booking repeating.":
    "The chosen dates no longer fit this room's booking window. Update the dates to keep this booking repeating.",
  "A recurring booking needs at least 2 dates. Add another date, or book this date on its own.":
    "A recurring booking needs at least 2 dates. Add another date, or book this date on its own.",
  "This room no longer offers recurring bookings. You can still book a single date.":
    "This room no longer offers recurring bookings. You can still book a single date.",
  "We couldn't price this recurring booking. Try different dates, or book a single date instead.":
    "We couldn't price this recurring booking. Try different dates, or book a single date instead.",
  "Update the dates": "Update the dates",
  "Book a single date instead": "Book a single date instead",
  "Remove the promo code": "Remove the promo code",
  Repeat: "Repeat",
  "Ends after": "Ends after",
  "Fewer bookings": "Fewer bookings",
  "More bookings": "More bookings",
  "Checking your dates…": "Checking your dates…",
  "We couldn't check these dates. Try again.":
    "We couldn't check these dates. Try again.",
  "This date isn't available at this time.":
    "This date isn't available at this time.",
  "This date and time can't repeat inside the booking window.":
    "This date and time can't repeat inside the booking window.",
  "Tinted dates are your recurring booking.":
    "Tinted dates are your recurring booking.",
  "Review all {count} bookings": "Review all {count} bookings",
  "Review bookings": "Review bookings",
  "Dates and repeat": "Dates and repeat",
  "Choose a date": "Choose a date",
  "Full-day booking: the daily rate has been applied":
    "Full-day booking: the daily rate has been applied",
  Table: "Table",
  "Ask Jus": "Ask Jus",
  Beta: "Beta",
  "New chat": "New chat",
  "Ask Jus ran into a problem": "Ask Jus ran into a problem",
  "Reload the page to use Ask Jus.": "Reload the page to use Ask Jus.",
  "Start a new chat, or reload the page if this keeps happening.":
    "Start a new chat, or reload the page if this keeps happening.",
  "We couldn't verify your sign-in. Try again or refresh the page.":
    "We couldn't verify your sign-in. Try again or refresh the page.",
  "You don't have access to Ask Jus for this account.":
    "You don't have access to Ask Jus for this account.",
  "Ask Jus is temporarily unavailable. Try again in a moment.":
    "Ask Jus is temporarily unavailable. Try again in a moment.",
  "Something went wrong while getting your answer.":
    "Something went wrong while getting your answer.",
  "Couldn't reach Ask Jus. Check your connection and try again.":
    "Couldn't reach Ask Jus. Check your connection and try again.",
  "The answer took too long.": "The answer took too long.",
  "This conversation is too long. Start a new chat.":
    "This conversation is too long. Start a new chat.",
  "Hi, I'm Jus.": "Hi, I'm Jus.",
  "I've been through your orders, revenue and room usage. Ask me anything about them.":
    "I've been through your orders, revenue and room usage. Ask me anything about them.",
  "Suggested questions": "Suggested questions",
  "Suggested follow-up questions": "Suggested follow-up questions",
  "How many orders have we had this month?":
    "How many orders have we had this month?",
  "What was our revenue in the last 30 days?":
    "What was our revenue in the last 30 days?",
  "Which product types are booked the most?":
    "Which product types are booked the most?",
  "How does this month's revenue compare with last month?":
    "How does this month's revenue compare with last month?",
  "What was meeting-room utilization last month?":
    "What was meeting-room utilization last month?",
  "What were last month's unbooked meeting-room hours worth?":
    "What were last month's unbooked meeting-room hours worth?",
  "How does this month compare with last month?":
    "How does this month compare with last month?",
  "Ask Jus conversation": "Ask Jus conversation",
  "Jump to latest": "Jump to latest",
  Jus: "Jus",
  "Jus is reading your numbers…": "Jus is reading your numbers…",
  "Complex questions can take up to a minute":
    "Complex questions can take up to a minute",
  "You stopped this answer": "You stopped this answer",
  Failed: "Failed",
  Copy: "Copy",
  "Answer copied": "Answer copied",
  "Good answer": "Good answer",
  "Bad answer": "Bad answer",
  "What was good about this answer?": "What was good about this answer?",
  "What went wrong with this answer?": "What went wrong with this answer?",
  Accurate: "Accurate",
  Relevant: "Relevant",
  Detailed: "Detailed",
  Other: "Other",
  Inaccurate: "Inaccurate",
  "Not relevant": "Not relevant",
  "Too vague": "Too vague",
  "Comment (optional)": "Comment (optional)",
  "Send feedback": "Send feedback",
  "Feedback sent": "Feedback sent",
  "Couldn't send your feedback. Try again.":
    "Couldn't send your feedback. Try again.",
  "Ask a question": "Ask a question",
  Send: "Send",
  Stop: "Stop",
  "Answer ready": "Answer ready",
  "Ask Jus from any page": "Ask Jus from any page",
  "Jus has been through your orders, revenue and room usage, and answers from whatever page you're on.":
    "Jus has been through your orders, revenue and room usage, and answers from whatever page you're on.",
  Shortcut: "Shortcut",
  "Got it": "Got it",
  "Get insights on these orders": "Get insights on these orders",
  "Give me insights on these orders.": "Give me insights on these orders.",
  "Monthly report": "Monthly report",
  "On the 1st of each month": "On the 1st of each month",
  "Last month's revenue, bookings and how full your rooms were, emailed to your team. Choose who gets it, or turn it off.":
    "Last month's revenue, bookings and how full your rooms were, emailed to your team. Choose who gets it, or turn it off.",
  "Sent to your admins": "Sent to your admins",
  "Monthly report saved.": "Monthly report saved.",
  "Flexspace writes and sends this email on the 1st of each month — you choose who gets it.":
    "Flexspace writes and sends this email on the 1st of each month — you choose who gets it.",
  "Who gets it": "Who gets it",
  "With no one listed, it goes to your dashboard admins.":
    "With no one listed, it goes to your dashboard admins.",
  Search: "Search",
  "Review and sign agreement": "Review and sign agreement",
  "Page {current} of {total}": "Page {current} of {total}",
  "Zoom in": "Zoom in",
  "Zoom out": "Zoom out",
  "Membership agreement": "Membership agreement",
  "Membership agreement (updated)": "Membership agreement (updated)",
  "Full legal name": "Full legal name",
  "Type your own full legal name, even if you are signing for a company. This signs the membership agreement.":
    "Type your own full legal name, even if you are signing for a company. This signs the membership agreement.",
  "After you pay, we'll email you the full agreement with your signature.":
    "After you pay, we'll email you the full agreement with your signature.",
  "Scroll to the end and type your full legal name to continue.":
    "Scroll to the end and type your full legal name to continue.",
  "This agreement was updated while you were checking out. Please review the latest version and sign again.":
    "This agreement was updated while you were checking out. Please review the latest version and sign again.",
  "Please sign the membership agreement by typing your full legal name.":
    "Please sign the membership agreement by typing your full legal name.",
  "Please type your full legal name": "Please type your full legal name",
  "The agreement could not be displayed here.":
    "The agreement could not be displayed here.",
  "Open the agreement": "Open the agreement",
  "Higher rate": "Higher rate",
  "We couldn't find that location.": "We couldn't find that location.",
  "It may have been removed, or the link might be out of date.":
    "It may have been removed, or the link might be out of date.",
  "Back to Locations": "Back to Locations",
};
